/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SurveyFileResponseDTO,
    SurveyFileResponseDTOFromJSON,
    SurveyFileResponseDTOFromJSONTyped,
    SurveyFileResponseDTOToJSON,
} from './SurveyFileResponseDTO';

/**
 * 
 * @export
 * @interface SurveyResponseDTO
 */
export interface SurveyResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    categoryName: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    subcategoryName: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    regNum: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    gps: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    datetime: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    surveyId: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseDTO
     */
    statusId: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    statusName: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseDTO
     */
    priority: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseDTO
     */
    dppSent: SurveyResponseDTODppSentEnum;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    surveyLock: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseDTO
     */
    surveyLockUserId: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyResponseDTO
     */
    extApology: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyResponseDTO
     */
    extUrgency: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyResponseDTO
     */
    extPraise: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyResponseDTO
     */
    extInstitution: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyResponseDTO
     */
    extAnonym: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    adminNotes: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    _export: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    extTags: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    extInstitutionExtraInfo: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyResponseDTO
     */
    childSurveys: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    descAdded: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    gpsAdded: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    parcelAdded: string | null;
    /**
     * 
     * @type {Array<SurveyFileResponseDTO>}
     * @memberof SurveyResponseDTO
     */
    files: Array<SurveyFileResponseDTO>;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseDTO
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum SurveyResponseDTODppSentEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

export function SurveyResponseDTOFromJSON(json: any): SurveyResponseDTO {
    return SurveyResponseDTOFromJSONTyped(json, false);
}

export function SurveyResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'categoryName': json['category_name'],
        'subcategoryName': json['subcategory_name'],
        'regNum': json['reg_num'],
        'description': json['description'],
        'email': json['email'],
        'gps': json['gps'],
        'datetime': json['datetime'],
        'surveyId': json['survey_id'],
        'statusId': json['status_id'],
        'statusName': json['status_name'],
        'priority': json['priority'],
        'dppSent': json['dpp_sent'],
        'surveyLock': json['survey_lock'],
        'surveyLockUserId': json['survey_lock_user_id'],
        'extApology': json['ext_apology'],
        'extUrgency': json['ext_urgency'],
        'extPraise': json['ext_praise'],
        'extInstitution': json['ext_institution'],
        'extAnonym': json['ext_anonym'],
        'adminNotes': json['admin_notes'],
        '_export': json['export'],
        'extTags': json['ext_tags'],
        'extInstitutionExtraInfo': json['ext_institution_extra_info'],
        'childSurveys': json['child_surveys'],
        'descAdded': json['desc_added'],
        'gpsAdded': json['gps_added'],
        'parcelAdded': json['parcel_added'],
        'files': ((json['files'] as Array<any>).map(SurveyFileResponseDTOFromJSON)),
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function SurveyResponseDTOToJSON(value?: SurveyResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'category_name': value.categoryName,
        'subcategory_name': value.subcategoryName,
        'reg_num': value.regNum,
        'description': value.description,
        'email': value.email,
        'gps': value.gps,
        'datetime': value.datetime,
        'survey_id': value.surveyId,
        'status_id': value.statusId,
        'status_name': value.statusName,
        'priority': value.priority,
        'dpp_sent': value.dppSent,
        'survey_lock': value.surveyLock,
        'survey_lock_user_id': value.surveyLockUserId,
        'ext_apology': value.extApology,
        'ext_urgency': value.extUrgency,
        'ext_praise': value.extPraise,
        'ext_institution': value.extInstitution,
        'ext_anonym': value.extAnonym,
        'admin_notes': value.adminNotes,
        'export': value._export,
        'ext_tags': value.extTags,
        'ext_institution_extra_info': value.extInstitutionExtraInfo,
        'child_surveys': value.childSurveys,
        'desc_added': value.descAdded,
        'gps_added': value.gpsAdded,
        'parcel_added': value.parcelAdded,
        'files': ((value.files as Array<any>).map(SurveyFileResponseDTOToJSON)),
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}

